import React, { useEffect, useState } from "react";

import "./textField.css";
import TextFieldWrapper from "./textFieldWrapper";
import EyeIcon from "../../assets/icons/eyeIcon";
import CheckIcon from "../../assets/icons/checkIcon";
import XIcon from "../../assets/icons/xIcon";

interface TextFieldProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    onEnter?: () => void;
    placeholder?: string;
    type?: string;
    className?: string;
    maxLength?: number;
    hideMaxLength?: boolean; // If true, shows the current length and max length in the info
    autoFocus?: boolean;
    onFocus?: (value: boolean) => void;
    children?: any;
    showPasswordEye?: boolean;
    onValidate?: (value: string) => boolean;
    validationName?: string;
}

export default function TextField(props: TextFieldProps) {

    const inputRef = React.useRef<HTMLInputElement>(null);

    const [shown, setShown] = React.useState(false);
    const [eyeIconTop, setEyeIconTop] = React.useState(0);

    const [valid, setValid] = useState<boolean>(false);

    useEffect(() => {
        if(inputRef.current) {
            setEyeIconTop(inputRef.current ? inputRef.current.offsetHeight / 2 + inputRef.current.offsetTop + 2 : 0);
        }
    }, [inputRef.current]);

    useEffect(() => {
        if(props.onValidate) {
            setValid(props.onValidate(props.value));
        }
    }, [props.value, props.onValidate]);

    return <TextFieldWrapper
    info={props.maxLength && !props.hideMaxLength ? props.value.length + "/" + props.maxLength : undefined}
    className={props.className}
    label={props.label}
    labelRight={props.validationName ? (valid ? <span className="valid"><CheckIcon/> valid {props.validationName}</span> : <span className="invalid"><XIcon/> Invalid {props.validationName}</span>) : undefined}
    >
        <input
            type={props.showPasswordEye ? (shown ? "text" : "password") : props.type || "text"}
            autoFocus={props.autoFocus}
            value={props.value}
            ref={inputRef}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                if(e.key === "Enter" && props.onEnter) {
                    props.onEnter();
                }
            }}
            onFocus={() => {
                if(props.onFocus) props.onFocus(true);
            }}
            onBlur={() => {
                setTimeout(() => {
                    
                    if(props.onFocus) {
                            props.onFocus(false);
                    }
                }, 0);
            }}
            onChange={(e) => {
                if(props.maxLength && e.target.value.length > props.maxLength) return;
                props.onChange(e.target.value)
            }}
            placeholder={props.placeholder}
        />
        {props.children}
        {props.showPasswordEye ? 
        <div style={{
            top: eyeIconTop,
        }} className="password-eye" onClick={() => {
            setShown(!shown);
        }}>
            <EyeIcon off={shown}/>
        </div>
        : <></>}
    </TextFieldWrapper>;
}